/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from './http-client'

export class DocsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags docs-controller
   * @name ApiDocs
   * @request GET:/{service}/v3/api-docs/**
   */
  apiDocs = (service: string, params: RequestParams = {}) =>
    this.http.request<object, any>({
      path: `/${service}/v3/api-docs/**`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static apiDocsPath = '/${service}/v3/api-docs/**'
  static apiDocsMethod = 'GET'
}
